import { IFrameContent } from '@sly/frontend/react/shared/types/usePrefetch';
import MarketingPageTitle from 'sly/hubPage/components/HubDynamicContent/MarketingPageTitle';
import MarketingPageWrapper from 'sly/hubPage/components/MarketingPageWrapper';

interface IFrameContentProps {
  iframeContent: IFrameContent;
  isMarketingPage: boolean;
}

interface IframeCodeComponentProps {
  iframeCode: string;
}

const IframeCodeComponent = ({ iframeCode }: IframeCodeComponentProps) => {
  return (
    <>
      {iframeCode && (
        <div
          className='dynamic-editor !font-b-m'
          dangerouslySetInnerHTML={{
            __html: iframeCode,
          }}
          data-tp-id='gen-div-ac0df881-a0b6-42d1-affc-ef8b02624471'
        />
      )}
    </>
  );
};

export default function IframeContentComponent({
  iframeContent,
  isMarketingPage,
}: IFrameContentProps) {
  const { title, id, enable, iframeCode } = iframeContent || {};
  if (!enable || !iframeCode) {
    return <></>;
  }

  return (
    <>
      {isMarketingPage ? (
        <>
          <MarketingPageWrapper key={`iframe${id}`}>
            <MarketingPageTitle title={title || ''} mb='l' />
            <div
              className='rounded-box w-full p-l md:w-[42.5rem]'
              data-tp-id='gen-Block-43aeb522-8a18-4781-8e9f-a76465cfab84'
            >
              <IframeCodeComponent iframeCode={iframeCode} />
            </div>
          </MarketingPageWrapper>
        </>
      ) : (
        <>
          <div
            className='dynamic-editor mx-m mb-l w-[calc(100%-2rem)] md:mx-auto md:mb-xl md:w-[31.5rem] lg:w-[42.5rem]'
            key={`iframe${id}`}
          >
            {title && <h3>{title}</h3>}
            <IframeCodeComponent iframeCode={iframeCode} />
          </div>
        </>
      )}
    </>
  );
}
